import React, { FC, useState } from 'react'
import { Slider as MuiSlider, withStyles, IconButton, makeStyles, Theme } from '@material-ui/core'
import { VolumeUp, VolumeOff } from '@material-ui/icons'
import { useAppState } from 'providers'

interface IVolumeSlider extends React.HTMLAttributes<HTMLDivElement> {
  volume: number
  setVolume: (volume: number) => void
  drawerOpen: boolean
}

const Slider = withStyles({
  thumb: {
    height: 12,
    width: 12,
    border: 'none',
    borderRadius: 50,
    marginTop: -5,
    boxShadow: 'none',
    '&:focus, &:hover, &$active': {
      boxShadow: 'none'
    }
  }
})(MuiSlider)

export const VolumeSlider: FC<IVolumeSlider> = ({ volume, setVolume, drawerOpen, ...props }) => {
  const { setUserInitiatedMute } = useAppState()
  const [previousVolume, setPreviousVolume] = useState<number>(0.3)
  const classes = useStyles({ drawerOpen })
  const handleChange = (_: any, newValue: number | number[]) => {
    setVolume(newValue as number)
  }

  const handleMuteClick = () => {
    if (volume !== 0) {
      setPreviousVolume(volume)
      setVolume(0)
      setUserInitiatedMute(true)
    } else {
      setVolume(previousVolume)
      setUserInitiatedMute(false)
    }
  }

  return (
    <div {...props} className={classes.root}>
      <IconButton
        size='small'
        color={'primary'}
        className={classes.button}
        disableFocusRipple
        disableRipple
        disableTouchRipple
        onClick={handleMuteClick}
      >
        {volume === 0 ? <VolumeOff /> : <VolumeUp />}
      </IconButton>
      <Slider className='slider' color={'primary'} value={volume} onChange={handleChange} step={0.05} max={1} min={0} />
    </div>
  )
}

interface StyleProps {
  drawerOpen: boolean
}
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'absolute',
    right: (props: StyleProps) => (props.drawerOpen ? 359 : 89),
    bottom: 45,
    transition: 'right 0.2s ease-in-out',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 180,
    [theme.breakpoints.down('lg')]: {
      bottom: 25,
      width: 150
    },
    [theme.breakpoints.down('md')]: {
      bottom: 19,
      width: 120
    },
    [theme.breakpoints.down('sm')]: {
      right: '20px !important'
    }
  },
  button: {
    marginRight: '.5rem'
  }
}))
